module.exports = __webpack_public_path__ + "static/media/Udit2.d8dd35d4.jpg";